import * as React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { get } from 'lodash';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import GenericInput from "../common/inputv2/GenericInput";
import EmailOrPhoneNumber from "../common/inputv2/EmailOrPhoneNumber";
import Text from "../common/input/text";
import * as types from "../../constants/actionTypes";
import MiniSpinner from "../common/MiniSpinner";

class OnTheFlyVisitModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emailOrNumber: "",
            reason: "",
            formSubmitted: false
        };
        this.joinTheRoom = this.joinTheRoom.bind(this);
    }

    componentDidMount() {
        logUI("UI.OnTheFlyVisitModal.ComponentDidMount", new Date(), Tools.getURLPath());
        if (this.props.showModal) {
            logUI("UI.OnTheFlyVisitModal.Displayed", new Date(), Tools.getURLPath());
        }
    }

    createVirtualRoom = () => {
        const { name, emailOrNumber, reason, isMobileNumberValid } = this.state;
        const { employeeEpicId, employeeName, _isMobileNumber, createVirtualRoom } = this.props;
        const serverData = window.serverData && window.serverData.data ? window.serverData.data : {};
        const { onTheFlyDepartmentId = null, onTheFlyDepartmentName = null, onTheFlyVisitTypeId = null, onTheFlyVisitTypeName = null } = serverData;

        const payload = {
            patientName: name,
            patientPhoneOrEmail: isMobileNumberValid ? emailOrNumber.match(/\d/g).join("") : emailOrNumber,
            notes: reason,
            providerExternalId: employeeEpicId,
            providerName: employeeName,
            departmentInternalId: onTheFlyDepartmentId,
            departmentName: onTheFlyDepartmentName,
            visitTypeInternalId: onTheFlyVisitTypeId,
            visitTypeName: onTheFlyVisitTypeName
        };

        if (isMobileNumberValid) {
            _isMobileNumber(emailOrNumber, isMobileNumber => {
                if (isMobileNumber.error || !isMobileNumber.isMobile) {
                    this.setState({ validMobileNumber: false, errors: 'Please enter a valid mobile number.' });
                }
                else {
                    createVirtualRoom(payload);
                    this.setState({ formSubmitted: true, mobileNumberConfirmed: true, errors: {} });
                }
            });
        }
        else {
            createVirtualRoom(payload);
            this.setState({ formSubmitted: true, validMobileNumber: true, errors: {} });
        }
        logUI("UI.OnTheFlyVisitModal.CreateVirtualRoom.Clicked", new Date(), Tools.getURLPath(), { ...payload });
    }

    onFormSubmit = (event) => {
        event.preventDefault();
        const { isEmailOrNumberValid, name } = this.state;
        this.setFormErrors();

        if (isEmailOrNumberValid && name && name.length > 0) {
            this.createVirtualRoom();
        }
    }

    setFormErrors = () => {
        const errors = {};
        const { isEmailOrNumberValid, name } = this.state;

        if (!name && !isEmailOrNumberValid)
            errors.name = errors.emailOrNumber = true;
        else if (!name && isEmailOrNumberValid)
            errors.name = true;
        else if (!isEmailOrNumberValid && name)
            errors.emailOrNumber = true;
        this.setState({ errors: 'Please complete the required fields.' });
    }

    closeModal = () => {
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
        logUI("UI.OnTheFlyVisitModal.Closed", new Date(), Tools.getURLPath());
    }

    onAction = (isApptCreated, resend) => {
        if (!isApptCreated) {// TRYAGAIN Click
            this.setState({
                formSubmitted: false,
                emailOrNumber: "",
                reason: "",
                errors: {},
                isEmailOrNumberValid: false,
                name: "",
                visitSuccess: false
            });
            logUI("UI.OnTheFlyVisitModal.tryAgain.Clicked", new Date(), Tools.getURLPath());
        }
        else {
            // SHARE APPT API CALL
            const csnId = get(this.props, 'onTheFlyVisit.room.id', '');
            const { name, emailOrNumber, isMobileNumberValid } = this.state;
            if (isMobileNumberValid) {
                this.props.sendSms(csnId, emailOrNumber.match(/\d/g).join(""), name, () => this.setState({ shareLinkSent: true }))
                logUI(`UI.OnTheFlyVisitModal.Mobile${resend ? ".Resend" : ""}.ShareVisitLink.Clicked`, new Date(), Tools.getURLPath(), { csnId, number: emailOrNumber.match(/\d/g).join(""), name });
            } else {
                this.props.sendEmail(csnId, emailOrNumber, name, () => this.setState({ shareLinkSent: true }))
                logUI(`UI.OnTheFlyVisitModal.Email${resend ? ".Resend" : ""}.ShareVisitLink.Clicked`, new Date(), Tools.getURLPath(), { csnId, email: emailOrNumber, name });
            }
        }
        return;
    }

    joinTheRoom() {
        const roomId = get(this.props, 'onTheFlyVisit.room.id', '');
        const joinRoomRoute = "/providervideovisit/" + roomId;
        this.closeModal();
        this.props.history.push({ pathname: joinRoomRoute, state: { onFlyVisit: true } });
        logUI("UI.OnTheFlyVisitModal.JoinVirtualRoom.Clicked", new Date(), Tools.getURLPath(), { roomId });
    }

    render() {
        const { name, emailOrNumber, formSubmitted, reason, errors, isEmailValid, isMobileNumberValid, shareLinkSent } = this.state;
        const { showModal, visitSuccess, smsVideoVisitLink, emailVideoVisitLink, createRoomWaiting, isMobileNumber } = this.props;
        const nameMarkup = <strong>{name}</strong>;
        const emailOrMobileMarkup = <strong>{emailOrNumber}</strong>;
        let shareLinkSuccess = isMobileNumberValid ? smsVideoVisitLink && smsVideoVisitLink.isSuccess : emailVideoVisitLink && emailVideoVisitLink.isSuccess;
        const showSpinner = createRoomWaiting || get(smsVideoVisitLink, 'isWaiting', false) || get(emailVideoVisitLink, 'isWaiting', false);
        const formErrors = errors;// && Object.keys(errors).length > 0;

        return (
            <div>
                <Modal className={`on-the-fly-modal${formSubmitted && typeof (shareLinkSent) !== "undefined" ? shareLinkSuccess ? " modal-success" : " modal-failure" : ""}`} isOpen={showModal} toggle={this.closeModal}>
                    <ModalHeader toggle={this.closeModal}>
                        {formSubmitted && typeof (shareLinkSent) !== "undefined" &&
                            <div className="row">
                                <div className="col-12">
                                    <div><span className={shareLinkSuccess ? "icon-list-check" : "icon-input-clear"} /></div>
                                    <div>{shareLinkSuccess ? "Your visit link was successfully sent!" : "Your visit link was not delivered."}</div>
                                </div>
                            </div>
                        }
                    </ModalHeader>
                    <ModalBody className={`${formSubmitted && typeof (shareLinkSent) !== "undefined" ? "modal-submitted" : ""}`}>
                        {showSpinner ? <MiniSpinner /> :
                            <>{!formSubmitted &&
                                <div className="row">
                                    <div className="col-12 form-group">
                                        <h1 className="on-the-fly-modal__heading h4">On the Fly</h1>
                                        <div className="on-the-fly-modal__subheading">Create a new virtual room to consult with a patient or provider.</div>
                                    </div>
                                    <form className={'col-12' + (formErrors ? " form-submitted" : "")} onSubmit={this.onFormSubmit} noValidate >
                                        <div className="form-group">
                                            <GenericInput placeholder="Name" required
                                                value={name} name="name" autofocus showClearBtn
                                                onChange={(e, value) => { this.setState({ name: value }); formErrors && this.setFormErrors(); }}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <EmailOrPhoneNumber placeholder="Mobile Number or Email" value={emailOrNumber} name="emailOrNumber" showClearBtn validateOnMount required
                                                onChange={(value, { isValid, isValidEmail, isValidPhone }) => {
                                                    this.setState({
                                                        emailOrNumber: value,
                                                        isEmailOrNumberValid: isValid,
                                                        isEmailValid: isValidEmail,
                                                        isMobileNumberValid: isValidPhone
                                                    });
                                                    formErrors && this.setFormErrors();
                                                }
                                                }
                                            />
                                        </div>
                                        <div className="form-group">
                                            <Text name="reason" placeholder="Reason for on the fly visit (Optional)"
                                                id={"reasonForVisit"} value={reason}
                                                onChange={(e) => this.setState({
                                                    reason: e.target.value
                                                })}

                                                rows="5"
                                            />
                                        </div>
                                        <div className="text-center">
                                            {(!isMobileNumber || !isMobileNumber.waiting) && formErrors && <div className="form-submit-error-msg">{formErrors}</div>}
                                            <button className="btn btn-primary btn-action" type="submit">CREATE VIRTUAL ROOM</button>
                                        </div>
                                    </form>
                                </div>}
                                {formSubmitted ? typeof (shareLinkSent) === "undefined" ? <div className="row on-the-fly-modal__confirmation">
                                    <div className="col-12 form-group">
                                        <h1 className="on-the-fly-modal__heading h4">On the Fly</h1>
                                        <div className={`details-icon-prepend${visitSuccess ? " status-success" : " status-failure"}`}>
                                            <div className="icon-col"><span className={visitSuccess ? "icon-list-check" : "icon-input-clear"} /></div>
                                            <div className="details-col">{visitSuccess ? "Your visit was successfully created." : "Your visit could not be created."}</div>
                                        </div>
                                        <hr />
                                        <div className="row">
                                            <div className="col-12">
                                                <strong>NAME</strong>
                                            </div>
                                            <div className="col-12 form-group">
                                                <span>{name}</span>
                                            </div>
                                            <div className="col-12">
                                                <strong>{isEmailValid ? "EMAIL" : "MOBILE"}</strong>
                                            </div>
                                            <div className="col-12 form-group">
                                                <span>{emailOrNumber}</span>
                                            </div>

                                            {reason && <> <div className="col-12">
                                                <strong>REASON FOR VISIT</strong>
                                            </div>
                                                <div className="col-12 form-group reason">
                                                    {reason}
                                                </div>
                                            </>}
                                        </div>
                                        <div className="row share-btn-group">
                                            <div className="col-12 text-center">
                                                <button className="btn btn-primary btn-action" onClick={() => { this.onAction(visitSuccess ? true : false, false) }}>{visitSuccess ? "SHARE VISIT LINK" : "TRY AGAIN"}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div> :
                                    <div className="row">
                                        <div className="col-12 text-center share-info">
                                            {shareLinkSuccess ? <div>The visit link was sent to {nameMarkup} <br />at {emailOrMobileMarkup}</div> : <div>The visit link was not sent to {nameMarkup} <br />at {emailOrMobileMarkup}</div>}
                                        </div>

                                        <div className="col-12 text-center">
                                            <button className="btn btn-primary btn-action join-room-btn" onClick={shareLinkSuccess ? () => { this.joinTheRoom() } : () => { this.onAction(true, true) }}>{shareLinkSuccess ? "JOIN VIRTUAL ROOM" : "RESEND"}</button>
                                        </div>
                                    </div>
                                    : null}
                            </>
                        }
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        employeeEpicId: state.domain.eid,
        employeeName: state.domain.pen,
        isMobileNumber: state.videoVisit.isMobileNumber,
        smsVideoVisitLink: state.videoVisit.smsVideoVisitLink,
        emailVideoVisitLink: state.videoVisit.emailVideoVisitLink,
        visitSuccess: state.videoVisit.onTheFlyVisit.visitSuccess,
        onTheFlyVisit: state.videoVisit.onTheFlyVisit,
        createRoomWaiting: state.videoVisit.onTheFlyVisit.isWaiting
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        _isMobileNumber: (phoneNumber, callback) => dispatch({ type: types.IS_MOBILE_NUMBER, phoneNumber, waiting: true, callback }),
        sendSms: (room, mobileNumber, participantName, callback) =>
            dispatch({ type: types.SMS_VIDEO_VISIT_LINK, room, mobileNumber, participantName, callback }),
        sendEmail: (room, email, participantName, callback) =>
            dispatch({ type: types.EMAIL_VIDEO_VISIT_LINK, room, email, participantName, callback }),
        createVirtualRoom: (payload) => dispatch({ type: types.CREATE_VIRTUAL_ROOM, payload })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OnTheFlyVisitModal));